import React from 'react'

import { Button, BUTTON_TYPES } from '@src/quince-components/src'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { getLinkPath } from '@src/quince-site-integrated/src/utils'

import { Banner, SectionType, TextSection } from '../../contact-us.types'

import styles from './orders-return.module.scss'

interface Props {
  sections: SectionType[]
  title?: TextSection
  bannerData?: Banner
}

const OrdersAndReturnsSection = ({ sections = [], bannerData }: Props) => {
  return (
    <div className={styles.ordAndReturnWrapper}>
      <img className={styles.ordAndReturnWrapper__image} alt={'Cover'} src={bannerData?.image.file.url}></img>
      <div className={styles.ordAndReturn}>
        <div className={styles.ordersHeader}>Get support</div>

        <div className={styles.sections}>
          {sections.map((svg, idx) => (
            <Button
              className={styles.card}
              key={idx}
              type={BUTTON_TYPES.SECONDARY_LINK}
              round={false}
              onClick={() => {
                if (isBrowser()) {
                  window.Gladly.navigate()
                }
              }}
              href={getLinkPath(svg.textLink) as string}
            >
              <img className={styles.card__icon} alt={svg.textLink?.text} src={svg.svgDesktop?.file.url}></img>
              <span className={styles.card__text}>{svg.textLink?.text}</span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OrdersAndReturnsSection
